import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { CommonFormComponent } from './common-form/common-form.component';
import { BcacButtonModule } from 'bcac-lib/base-component/currency/bcac-button';
import { EditFormComponent } from './edit-form/edit-form.component';



@NgModule({
  declarations: [CommonFormComponent, EditFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgZorroAntdModule,
    BcacButtonModule
  ], exports: [
    CommonFormComponent,
    EditFormComponent
  ]
})
export class BcacFormModule { }
